import React from 'react';
import { Shield } from 'lucide-react';
import { SEO, breadcrumbs } from '../components/SEO';

export const Privacy: React.FC = () => {

  const sections = [
    {
      title: 'Information We Collect',
      content: [
        'Contact information when you subscribe to our newsletter (email address)',
        'Usage data including browser type, device information, and interaction with our website',
        'Cookies and similar tracking technologies to enhance your experience'
      ]
    },
    {
      title: 'How We Use Your Information',
      content: [
        'To send you newsletters and updates about our services',
        'To analyze website usage and improve our services',
        'To respond to your inquiries and support requests'
      ]
    },
    {
      title: 'Data Storage',
      content: [
        'Your data is stored securely on servers in the European Union',
        'We implement appropriate security measures to protect your information',
        'We retain your data only for as long as necessary to provide our services'
      ]
    },
    {
      title: 'Your Rights',
      content: [
        'You have the right to access, correct, or delete your personal data',
        'You can unsubscribe from our newsletter at any time',
        'You can request a copy of your data or ask us to delete it by contacting us'
      ]
    },
    {
      title: 'Contact Us',
      content: [
        'If you have any questions about this Privacy Policy, please contact us at contact@cemates.me'
      ]
    }
  ];

  return (
    <div className="min-h-screen bg-background">
      <SEO 
        title="Privacy Policy"
        description="Privacy Policy for Cemates.me. Learn how we collect, use, and protect your personal information."
        canonical="/privacy"
        jsonLd={breadcrumbs.privacy}
      />
      <div className="pt-32 pb-20">
        <div className="max-w-2xl mx-auto px-6">
          {/* Header */}
          <div className="mb-16">
            <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-muted mb-6">
              <Shield className="w-5 h-5 text-foreground" />
            </div>
            <h1 className="text-3xl font-semibold text-foreground mb-3">
              Privacy Policy
            </h1>
            <p className="text-muted-foreground text-sm">
              Last updated: April 27, 2024
            </p>
          </div>

          {/* Intro */}
          <div className="mb-12">
            <p className="text-muted-foreground leading-relaxed">
              At Cemates.me, we take your privacy seriously. This Privacy Policy explains how we collect, 
              use, and protect your personal information when you use our website and services.
            </p>
          </div>

          {/* Sections */}
          <div className="space-y-12">
            {sections.map((section, index) => (
              <div key={index}>
                <h2 className="text-lg font-medium text-foreground mb-4">
                  {section.title}
                </h2>
                <ul className="space-y-3">
                  {section.content.map((item, itemIndex) => (
                    <li key={itemIndex} className="text-muted-foreground text-sm leading-relaxed flex gap-3">
                      <span className="text-muted-foreground/50 select-none">•</span>
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};